import { FORM_TYPE, onPasswordResetSubmit } from '@atlas/react-forms';
import cx from 'classnames';
import { useState } from 'react';

import {
  type InitResetPasswordResponse,
  activeFormsRequest,
  initResetPasswordRequest,
} from 'api/forms';
import { Form } from 'components/Form';
import Loader from 'components/Loader';
import { useNotifications } from 'store';
import useLayout from 'utils/layout';
import { useSearchQuery } from 'utils/location';
import { Translation, useTranslation } from 'utils/translations';

import styles from './ResetPassword.module.scss';

const getActiveForms = () =>
  activeFormsRequest({
    query: {
      formType: FORM_TYPE.INIT_PASSWORD_RESET,
    },
  });

const InitResetPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [_, setQuery] = useSearchQuery();
  const [{ add }] = useNotifications();
  const layout = useLayout();

  const resetPasswordLabel = useTranslation(
    'successful_please_check_your_email',
  );
  const somethingWentWrongMessage = useTranslation('something_went_wrong');

  const handleSubmit = onPasswordResetSubmit(async (values) => {
    setIsLoading(true);
    const { id, ...rest } = values;

    try {
      return await initResetPasswordRequest({
        body: {
          id: Number(id),
          values: rest,
        },
      });
    } catch (error) {
      add({
        text: (error as Error).message,
      });
    } finally {
      setIsLoading(false);
    }
  });

  const onSubmitHandler = (clientData: InitResetPasswordResponse) => {
    if (!clientData.success) {
      add({
        text: somethingWentWrongMessage,
      });
      return;
    }

    if (clientData.resetType === 'PHONE') {
      setQuery({
        resetType: clientData.resetType,
        token: clientData.publicToken,
      });
      return;
    }

    setQuery({
      emailSuccess: 'true',
    });

    add({
      text: resetPasswordLabel,
    });
  };

  return (
    <div className={cx(styles.content, styles[layout])}>
      <h3 className={styles.title}>
        <Translation message="reset_your_password" />
      </h3>
      <p className={styles.description}>
        <Translation message="you_will_receive_a_code_to_reset_your_old_password" />
      </p>
      {isLoading ? (
        <Loader />
      ) : (
        <Form
          formType={FORM_TYPE.INIT_PASSWORD_RESET}
          className={cx(styles.form, styles[layout])}
          // @ts-ignore
          handleSubmit={handleSubmit}
          // @ts-ignore
          onSubmit={onSubmitHandler}
          getActiveForms={getActiveForms}
          onError={() => {}}
          submitButtonText="form_submit_send_code"
        />
      )}
    </div>
  );
};

export default InitResetPassword;
